import { randCompanyName, randSlug } from '@ngneat/falso';
import {
  IOrganisation,
  IStaffer,
  OrganisationStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  DocumentReference,
  Properties,
  Region,
} from '@principle-theorem/shared';

export class OrganisationMock
  extends BaseFirestoreMock<Properties<IOrganisation>>
  implements Properties<IOrganisation>
{
  name = randCompanyName();
  slug = randSlug();
  status = OrganisationStatus.Active;
  region = Region.Australia;
  integrations = {};
  settings = {
    multifactor: {
      enabled: false,
    },
  };
  optInFeatures = [];
  bigqueryDataset = 'org_mock';
  accountManagers: DocumentReference<IStaffer>[] = [];
}
